import {routeTree} from '@/routeTree.gen'
import {TanstackQuery} from '@cypro/ui/integrations/tanstack-query'
import {createRouter, SearchParamError, useNavigate, ErrorComponent} from '@tanstack/react-router'

export const rqContext = TanstackQuery.getContext()

export const router = createRouter({
  routeTree,
  context: {...rqContext},
  defaultPreload: false,
  scrollRestoration: true,
  defaultErrorComponent: ({error}) => {
    const navigate = useNavigate()
    if (error instanceof SearchParamError) {
      return navigate({to: '.', search: {}})
    }
    return <ErrorComponent error={error} />
  },
})

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router
  }
}
